<script setup>
  import { RouterView } from 'vue-router'
</script>

<template>
  <RouterView />
</template>

<script>
  export default {
    name: 'App',
    mounted() {
      this.$primevue.config.ripple = false
    },
  }
</script>
